import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'

export const receivedSmsTable = 'receivedSmsTable' as RegisteredServices
export const receivedSmsFilterModalId: TmWrappers = 'receivedSmsFilterModal'

export type ReceivedSmsFilterModalParams = {
  serviceId: RegisteredServices
}
